export default class Dropdown {
  private open = false
  private ui!: {
    labelEl: HTMLElement | null
    itemsEl: HTMLElement | null
    options: HTMLLIElement[]
  }

  constructor(private el: HTMLElement) {
    this.ui = {
      labelEl: this.el.querySelector('label'),
      itemsEl: this.el.querySelector('ul'),
      options: []
    }
    if (this.ui.itemsEl) {
      this.ui.options = Array.from(this.ui.itemsEl.querySelectorAll('li'))
    }

    this.el.addEventListener('click', () => this.toggle())
    this.el.addEventListener('keydown', e => this.scrollToLetter(e))
    if (this.ui.itemsEl) {
      this.ui.itemsEl.addEventListener('click', event => this.handleItemsClick(event))
    }
    document.addEventListener('click', event => this.handleDocumentClick(event))
  }

  public toggle(open = !this.open) {
    if (this.open === open) {
      return
    }

    this.open = open
    this.el.classList.toggle('wz-dropdown-field--open', this.open)
  }

  public setValue(country: string, iso: string, code: string): void {
    this.el.dataset.country = country
    this.el.dataset.iso = iso
    this.el.dataset.code = code
    if (this.ui.labelEl) {
      this.ui.labelEl.innerHTML = code
    }
  }

  private handleItemsClick(event: Event): void {
    const targetElement = event.target as HTMLElement
    if (targetElement.tagName !== 'LI') {
      return
    }

    event.stopPropagation()

    const country = targetElement.dataset.country || ''
    const code = targetElement.dataset.code || ''
    const iso = targetElement.dataset.iso || ''
    this.setValue(country, iso, code)
    this.el.dispatchEvent(new CustomEvent('change', { detail: { data: { country, code, iso } } }))

    this.toggle(false)
  }

  private handleDocumentClick(event: Event): void {
    const targetElement = event.target as HTMLElement
    if (this.open && !this.el.contains(targetElement)) {
      this.toggle(false)
    }
  }

  private scrollToLetter(event: KeyboardEvent): void {
    const isLetter = /^[a-z]$/i.test(event.key)

    if (isLetter) {
      const key = event.key.toLowerCase()

      const item = this.ui.options.find(el => {
        const country = el.dataset.country || ''
        return country[0].toLowerCase() === key
      })

      if (item && this.ui.itemsEl) {
        const top = item.offsetTop
        this.ui.itemsEl.scrollTop = top
      }
    }
  }
}
